import React, { useEffect, useState } from "react";
import {
  Box,
  Input,
  Table,
  TableContainer,
  IconButton,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button
} from "@chakra-ui/react";
import CustomButton from "../../../../elements/customButton";
import Pagination from "../../../../elements/Pagination";
import { ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";
import Loader from "../../../../elements/loader";
import { bindActionCreators } from "redux";
import { ActionCreators } from "../../../../../redux/actions";
import { connect, useSelector } from "react-redux";
import NoData from "../../../../elements/NoData";


const CPMissed = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(props?.collectionData?.length / PER_PAGE);

  const handlePageClick = ({ selected: selectedPage }) => {  setCurrentPage(selectedPage)  };

  const handleVerify = () => {}

  return (
    <>
      {props?.collectionData?.length > 0  ? (
        <Box mt={2} className="custom_table_wrapper custom_table_wrapper2">
          <TableContainer>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>S.No.</Th>
                  <Th>Loan Details</Th>
                  <Th>Loan Disbursed Date</Th>
                  <Th>Loan EMI Date</Th>
                  <Th>EMI Amount</Th>
                  <Th>EMI Payable</Th>
                  <Th>Loan Amount</Th>
                  <Th>Username</Th>
                  <Th>Mobile number</Th>
                  <Th>Email</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {props?.collectionData
                  ?.slice(offset, offset + PER_PAGE)
                  ?.map((item, index) => {
                    const serialNumber = offset + index + 1;
                    return (
                      <Tr key={index}>
                        <Td>
                          <Text className="font-poppins table_text">
                            {serialNumber}
                          </Text>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.loan_number ? item?.loan_number : "NA"}
                          </Text>
                        </Td>
                        <Td>
                        <Text className="font-poppins  table_text">
                            {item?.disbursed_date ? item?.disbursed_date : "NA"}
                          </Text>
                          <Td>
                        </Td>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.emi_date
                              ? item?.emi_date
                              : "Not Assigned"}
                          </Text>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.emiAmount ? item?.emiAmount : "NA"
                              }
                          </Text>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.emi_outstanding_dues ? item?.emi_outstanding_dues : "NA"
                              }
                          </Text>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.loan_amount ? item?.loan_amount  : "NA"
                              }
                          </Text>
                        </Td>
                        <Td>
                          <Text className="font-poppins table_text">
                            {item?.first_name ? item?.first_name.concat(" ",item?.last_name)
                               : "Not Available"}
                          </Text>
                        </Td>
                        <Td>
                        <Text className="font-poppins table_text">
                            {item?.mobile  ? item?.mobile
                               : "Not Available"}
                          </Text>
                       </Td>
                       <Td>
                        <Text className="font-poppins table_text">
                            {item?.email  ? item?.email
                               : "Not Available"}
                          </Text>
                       </Td>
                        <Td>
                          {/* <Box className="actions_td action_table">
                            <IconButton
                              onClick={() =>
                                props.handleVerify(item)
                              }
                            >
                              <ChevronRightIcon />
                            </IconButton>
                          </Box> */}
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <Pagination
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </Box>
      ) : (
        <NoData title="No Record Found" />
      )}
    </>
  );
};


const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  });
  
  export default connect(null, mapDispatchToProps)(CPMissed);
  
